// extracted by mini-css-extract-plugin
export default {"tooltip":"zU-z","arrow":"AU-z"};